import React from 'react';
import { PieChart, Pie, Cell } from 'recharts';
import { caseStatus } from '../../constants';

const InboxListItemStatusPie = ({ status }) => {
  const colors = ['#999', '#cfcfcf'];
  const totalValue = 100;
  let pieValue;

  const {
    workFlowStatusDemo: {
      CASE_CREATED,
      AWAITING_UPLOAD,
      AWAITING_ANALYSIS,
      ANALYSIS_SUBMITTED,
    },
  } = caseStatus;


  switch (status) {
    case CASE_CREATED:
      pieValue = 10;
      break;
    case AWAITING_UPLOAD:
      pieValue = 40;
      break;
    case AWAITING_ANALYSIS:
      pieValue = 60;
      break;
    case ANALYSIS_SUBMITTED:
      pieValue = 100;
      break;
    default:
      pieValue = 0;
  }

  const data = [
    { name: 'status', value: pieValue },
    { name: 'other', value: totalValue - pieValue },
  ];

  return (
    <PieChart width={50} height={50} className="sidebar__item-status-pie">
      <Pie data={data} outerRadius="100%" animationBegin={100} dataKey="value" nameKey="name">
        {
          data.map((entry, index) => <Cell key={index} fill={colors[index % colors.length]} />)
        }
      </Pie>
    </PieChart>
  );
};

export default InboxListItemStatusPie;
